<template lang="pug">
  .c-lst-port-info
    h2 {{ content.title }}
    h3(v-if="content.article.role") {{ content.article.role }}
    .c-lst-port-info-tag
      div(v-if="content.genres.length > 0")
        strong ジャンル
        | {{ content.genres.join('、') }}
      div(v-if="content.apps.length > 0")
        strong 使用編集ソフト
        | {{ content.apps.join('、') }}
      div(v-if="content.article.camera > 0")
        strong 使用カメラ
        | {{ content.article.camera }}
      div(v-if="content.article.client")
        strong クライアント
        | {{ content.article.client }}
</template>
<script>
export default {
  props: {
    content: {
      type: Object,
      required: true
    }
  }
}
</script>
